var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider",on:{"click":_vm.onClick}},[_c('div',{staticClass:"slider-bar",style:({ width: `${_vm.format(_vm.value)}%` })},[_c('div',{staticClass:"slider-btn",on:{"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove,"touchend":_vm.onTouchend,"touchcancel":_vm.onTouchend}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }